import React from 'react'
import { FormattedMessage } from 'react-intl'
import { string, shape, number } from 'prop-types'
import { Download, Booking } from '@gympass/yoga-icons'
import tokens from '@gympass/yoga-tokens'

import getCommercialOfferPdf from '@client/services/print'
import defaultReportNameByCountry from '@client/mapper/defaultReportNameByCountry'
import { updateSimulation } from '@client/services/simulate'

import useDataLayer from '@hooks/useDataLayer'
import useInternationalization from '@hooks/useInternationalization'

import { openChat } from '@client/utils/chatbot'

import {
  ProposalActions,
  ProposalActionsItem,
  ProposalActionsDescription,
} from './OfferActions.style'

export default function OfferActions({ contact }) {
  const { country } = useInternationalization()
  const { events } = useDataLayer()

  function handleDownloadFile(file) {
    const url = window.URL.createObjectURL(new Blob([file]))

    const link = document.createElement('a')

    link.href = url

    link.setAttribute(
      'download',
      `${defaultReportNameByCountry[country]}-${contact.company}.pdf`
    )

    document.body.appendChild(link)

    link.click()
  }

  async function getCommercialOfferFile() {
    const discount =
      contact.proposalValue - contact.proposalValueWithoutDiscount

    const data = {
      personalInfo: {
        company: contact.company || contact.companyName,
        fullName: `${contact.firstName} ${contact.lastName}`,
        email: contact.email,
        phone: contact.mobilePhone,
      },
      companyInfo: {
        employeesNumber: contact.employeesNumber,
      },
      commercialOffer: {
        originalValue: contact.proposalValueWithoutDiscount,
        value: contact.proposalValue,
        discount,
      },
    }

    const response = await getCommercialOfferPdf(data, country)

    handleDownloadFile(response.data)

    events.interactionWithProposalDownload()
  }

  async function contactUsAction() {
    await updateSimulation({
      id: contact.id,
      funnelStage: 'talk_to_specialist',
    })

    openChat()
  }

  return (
    <ProposalActions>
      <ProposalActionsItem onClick={getCommercialOfferFile}>
        <Download fill={tokens.colors.vibin} width={24} height={24} />
        <ProposalActionsDescription>
          <FormattedMessage id="smb_acquisition_commercial_offer.page.media.proposal_download" />
        </ProposalActionsDescription>
      </ProposalActionsItem>

      <ProposalActionsItem onClick={contactUsAction}>
        <Booking fill={tokens.colors.vibin} width={24} height={24} />
        <ProposalActionsDescription>
          <FormattedMessage id="smb_acquisition_commercial_offer.page.call_to_action.contact_us" />
        </ProposalActionsDescription>
      </ProposalActionsItem>
    </ProposalActions>
  )
}

OfferActions.propTypes = {
  contact: shape({
    employeesNumber: number,
    id: string,
    specialistCalendar: string,
  }).isRequired,
}
